import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-notice\"><path d=\"M328.085333 266.666667l161.28-161.28a32 32 0 0 1 45.269334 0l161.28 161.28H970.666667v661.333333h-917.333334v-661.333333h274.752z m90.496 0h186.837334L512 173.248 418.581333 266.666667zM117.333333 330.666667v533.333333h789.333334v-533.333333h-789.333334zM234.666667 469.333333h554.666666v64H234.666667v-64z m0 192h277.333333v64H234.666667v-64z\" fill=\"\" p-id=\"28207\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol